import React from 'react';

interface BadgeProps {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
  children: React.ReactNode;
}

export function Badge({ variant = 'default', className = '', children }: BadgeProps) {
  const variantClasses = {
    default: 'bg-emerald-600 text-white',
    secondary: 'bg-gray-100 text-gray-900',
    destructive: 'bg-red-600 text-white',
    outline: 'border border-gray-300 bg-transparent text-gray-900',
  };

  // If className is provided, use it instead of variant classes
  const finalClassName = className
    ? `inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${className}`
    : `inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${variantClasses[variant]}`;

  return <div className={finalClassName}>{children}</div>;
}
